import React from 'react';
import { SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { AppInput } from './AppInput';
import { VillageSelect } from './VillageSelect';

/**
 * Address block shared by People / Vendor masters.
 * Address lines full width; village + PIN only (no repeated taluka/district/state).
 */
export function MasterAddressFields({
  villages,
  address1,
  address2,
  villageId,
  pin,
  onChange,
  errors = {},
}) {
  return (
    <VStack align="stretch" spacing={4}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <AppInput
          label="Address 1"
          placeholder="e.g. 99/2, Sanskar Nagar Old"
          value={address1}
          onChange={(e) => onChange({ address1: e.target.value })}
          maxLength={120}
          isInvalid={!!errors.address1}
          errorMessage={errors.address1}
        />
        <AppInput
          label="Address 2"
          placeholder="e.g. Nr. Garbi Chowk"
          value={address2}
          onChange={(e) => onChange({ address2: e.target.value })}
          maxLength={120}
          isInvalid={!!errors.address2}
          errorMessage={errors.address2}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <VillageSelect
          isRequired
          villages={villages}
          value={villageId}
          onChange={(id, v) =>
            onChange({
              villageId: id || '',
              pin: v?.pin || pin || '',
            })
          }
          helperText="From Village Master — PIN prefilled."
          showSummary={false}
          isInvalid={!!errors.villageId}
          errorMessage={errors.villageId}
        />
        <AppInput
          label="PIN Code"
          value={pin}
          onChange={(e) => onChange({ pin: e.target.value.replace(/\D/g, '').slice(0, 6) })}
          placeholder="From village / manual"
          helperText="Prefilled from village — editable."
          maxLength={6}
          isInvalid={!!errors.pin}
          errorMessage={errors.pin}
        />
      </SimpleGrid>

      {!villageId ? (
        <Text fontSize="13px" color="text.secondary">
          Select a village to link this record to Village Master.
        </Text>
      ) : null}
    </VStack>
  );
}
